<template>
  <v-dialog
    v-model="dialog"
    max-width="800px"
  >
    <v-form
      ref="form"
      v-model="valid"
      :lazy-validation="true"
      autocomplete="off"
    >
      <v-card>
        <v-card-title>
          <span class="headline font-weight-bold">Modifica Riparazione</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-autocomplete
                  label="Cliente"
                  v-model="customerModel"
                  :search-input.sync="customerSearch"
                  :items="customers"
                  :loading="isLoading"
                  hide-no-data
                  hide-selected
                  item-text="text"
                  item-value="id"
                  return-object
                  :rules="[rules.required]"
                  required
                ></v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="editedItem.serial"
                  label="IMEI"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="editedItem.brand"
                  label="Brand"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="editedItem.model"
                  label="Modello"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="editedItem.color"
                  label="Colore"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-textarea
                  v-model="editedItem.public_note"
                  label="Nota pubblica"
                ></v-textarea>
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-textarea
                  v-model="editedItem.private_note"
                  label="Nota privata"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="editedItem.price"
                  label="Prezzo"
                  type="number"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-col>

            </v-row>
          </v-container>
        </v-card-text>

        <v-card-text>
          <v-col>
            <v-row>
              <v-col>
                <h1 class="primary--text">Pezzi di Ricambio</h1>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-autocomplete
                  label="Cerca"
                  v-model="replacementModel"
                  :search-input.sync="replacementSearch"
                  :items="filteredReplacements"
                  :loading="isLoading"
                  hide-no-data
                  hide-selected
                  item-text="text"
                  item-value="id"
                  return-object
                ></v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                md="2"
                lg="1"
                class="pt-8"
              >
                <v-btn
                  small
                  color="primary"
                  @click="add()"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-list>
                  <v-list-item-group color="primary">
                    <v-list-item
                      v-for="(item, index) in editedItem.replacements"
                      :key="index"
                    >
                      <v-list-item-icon>
                        <v-icon
                          color="red"
                          @click="remove(index)"
                        >mdi-delete</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title>{{item.name}} {{item.model}} {{item.state}} {{item.color || ''}} | {{item.supplier.name}} {{item.cost}}€</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-col>
            </v-row>
          </v-col>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="close"
          >Cancella</v-btn>
          <v-btn
            color="primary"
            text
            @click="save"
          >Salva</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
  import axios from 'axios'
  import { mapMutations, mapGetters } from 'vuex'

  export default {
    name: 'EditForm',
    data() {
      return {
        search: null,
        customerSearch: null,
        replacementSearch: null,
        model: null,
        customerModel: null,
        replacementModel: null,
        customers: [],
        replacements: [],
        replacementSearchItems: [],
        isLoading: false,
        valid: false,
        editedItem: {},
        rules: {
          required: value => !!value || 'Campo obbligatorio.',
        },
        config: {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
          }
        },
      }
    },

    props:
    {
      item: { type: Object }
    },

    computed: {
      ...mapGetters([
        'getRiparazioniClientiEdit'
      ]),
      dialog: {
        get() {
          return this.getRiparazioniClientiEdit
        },
        set() {
          this.CHANGE_RIPARAZIONI_CLIENTI_EDIT(false)
        }
      },
      filteredReplacements() {
        return this.replacements.filter(el => el.amount > 0)
      },
    },

    methods: {
      ...mapMutations([
        'CHANGE_RIPARAZIONI_CLIENTI_EDIT'
      ]),

      async fetchRepairs() {

        const { data } = await axios.post(`${process.env.VUE_APP_API}/v2/repairs/customer/fetch-to-edit`, { id: this.item.id }, this.config)

        this.model = data
        this.editedItem = data

        // this.repairs = data.map(el => {

        //   el.text = `[${el.serial}] ${el.brand} ${el.model} ${el.color}`

        //   return el
        // })
      },

      async fetchCustomers() {

        const { data } = await axios.get(`${process.env.VUE_APP_API}/v2/customers/fetch`, this.config)

        this.customers = data.map(el => {

          el.text = `${el.name} ${el.surename} [${el.phone}]`

          return el
        })
      },

      async fetchReplacements() {

        const { data } = await axios.get(`${process.env.VUE_APP_API}/v2/replacements/fetch`, this.config)

        this.replacements = data.map(el => {
          el.text = `${el.amount}x ${el.name} ${el.model} ${el.state} ${el.color || ''} | ${el.supplier.name} ${el.cost}€`
          return el
        })
      },

      add() {
        this.editedItem.replacements.push(this.replacementModel)

        this.replacements = this.replacements.map(el => {
          if (el.id == this.replacementModel.id) {
            el.amount--
          }

          return el
        })

        this.replacementModel = null
      },

      remove(index) {

        this.replacements = this.replacements.map(el => {
          if (el.id == this.editedItem.replacements[index].id) {
            el.amount++
          }

          return el
        })

        this.editedItem.replacements.splice(index, 1);
      },

      close() {
        this.CHANGE_RIPARAZIONI_CLIENTI_EDIT(false)
      },

      async save() {
        if (this.$refs.form.validate()) {

          this.$emit('edit-submit', 'reset')

          const { data } = await axios.post(`${process.env.VUE_APP_API}/v2/repairs/customer/update`, { repair: this.editedItem, customer: this.customerModel }, this.config)

          if (data.status) {

            this.$emit('edit-submit', 'ok')
            this.close()
          } else {

            this.$emit('edit-submit', 'error')
          }

        }
      },
    },

    watch: {
      dialog(val) {
        val || this.close() && this.CHANGE_RIPARAZIONI_CLIENTI_EDIT(false)
      },

      async item(val) {

        this.fetchRepairs()
        // .then(() => {
        //   this.repairs.map(el => {
        //     if (el.id == val.id) {
        //       this.model = el
        //       this.editedItem = el
        //     }
        //   })
        // })

        this.fetchCustomers()
          .then(() => {
            this.customers.map(el => {
              if (el.name == val.name && el.surename == val.surename) {
                this.customerModel = el
              }
            })
          })

        await this.fetchReplacements()
      },

      model(val) {
        if (val) {
          this.editedItem = val
        }
      },
    },
  }
</script>

<style>
</style>